import React, { FC } from 'react';
import { isAndroid, isIOS, isMobile, isTablet } from 'react-device-detect';
import { PlaceholderAsset } from 'types/Asset';
import { StandardCover } from 'types/Cover';
import { CardContext } from 'types/Common';
import { Card } from 'components/Cards/Card/Card';
import { CardVariant } from 'components/Cards/Card/cardVariants';

export const PlaceholderCardPresenter: FC<{
    asset: PlaceholderAsset;
    cardContext: CardContext;
}> = ({ asset, cardContext }) => {
    const cover: StandardCover = {
        uuid: asset.id,
        id: asset.id,
        title: null,
        image: null,
        landscapeImage: null,
        metaData: null,
        path: null,
        circle: false,
        landscape: false,
        assetType: asset.type,
        rawData: asset,
        contentMarker: null,
        progressBar: null,
        renderPlayIcon: false,
        onPlayIconClicked: null,
        defaultRenderSecondLine: isAndroid || isIOS || isTablet || isMobile,
    };

    const variant = cardContext === CardContext.STRIPE && asset.isPortrait ? CardVariant.PORTRAIT : CardVariant.LANDSCAPE;

    return <Card variant={variant} context={cardContext} asset={cover} />;
};
